import { render, staticRenderFns } from "./PrivateFoundationCourses.vue?vue&type=template&id=b00142d2&"
import script from "./PrivateFoundationCourses.vue?vue&type=script&lang=js&"
export * from "./PrivateFoundationCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports